module.exports = __webpack_public_path__ + "static/media/bep20.0a5d3da7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment/networks/bep20.svg
// module id = 429
// module chunks = 7